@if (isVisible) {
  <div class="full-width" [formGroup]="formGroup" >
    <form-control-label [question]="componentData"></form-control-label>
    <div class="grid-x grid-margin-x">
      <div class="cell small-6">
        <div class="signature-line">{{signer.dateSigned | date}}</div>
        <div class="small-font-size">Date</div>
      </div>
      <div class="cell small-6">
        <div class="signature-line">
          @if (profile) {
            @if (hasAuthority) {
              <button class="minor-margin-right" (click)="sign()" aria-label="Affix Signature" [style.display]="signer.signerType == 'None' ? 'inline' : 'none'">
                <span class="show-for-sr">Affix Signature</span>
                <svg-icon icon="icon-signature" class="small" aria-hidden="true"></svg-icon>
              </button>
            }
            @if (!hasAuthority) {
              <span class="red bold">No signing authority for this document.</span>
            }
          } @else {
            Loading ...
          }
          {{signer.legalName}}
          <span [style.display]="showSignatureError ? 'inline' : 'none'" class="red bold">{{signatureError}}</span>
        </div>
        <div class="small-font-size">
          @if (isDelegateSignature) {
            <div>{{signer.authority}} {{signer.legalName}} for</div>
          }
          @if (chief) {
            <div>{{chief.fullLegalName}}, Chief of the</div>
          } @else {
            Loading ...
          }
          <div>Division of Oil and Gas Resource Management</div>
        </div>
      </div>
    </div>
  </div>
}

